<template>
  <b-modal
    id="test-modal"
    size="lg"
    ref="modal"
    title="Modal z formularzem"
    @hidden="onClose"
    @show="onShow"
  >
    <ValidationObserver ref="formValidation" tag="form" @submit.prevent="onSubmit" id="formTest">
      <b-form-group label="Email" label-for="email-input">
        <ValidationProvider name="E-mail" rules="required|email" v-slot="validationContext">
          <b-form-input
            id="email-input"
            v-model="model.email"
            type="email"
            :state="getValidationState(validationContext)"
          ></b-form-input>
          <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
        </ValidationProvider>
        <b-form-group label="Imie" label-for="name-input">
          <ValidationProvider name="name" rules v-slot="validationContext">
            <b-form-input
              id="name-input"
              v-model="model.name"
              type="text"
              :state="getValidationState(validationContext)"
            ></b-form-input>
            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
          </ValidationProvider>
        </b-form-group>
      </b-form-group>
    </ValidationObserver>
    <template v-slot:modal-footer="{cancel}">
      <b-button size="md" variant="info" type="submit" form="formTest">Zapisz</b-button>
      <b-button size="md" variant="outline-secondary" @click="cancel()">Anuluj</b-button>
    </template>
  </b-modal>
</template>

<script>
import ApiService from "@/services/api.service";

export default {
  props: {
    form: { type: Object }
  },
  data() {
    return {
      model: {}
    };
  },

  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    onShow() {
      if (this.$_.isEmpty(this.form) === false) {
        this.model = Object.assign({}, this.form);
      }
    },
    onClose() {
      this.model = {};
      this.$emit("onClose");
    },
    onSubmit() {
      this.$refs.formValidation.validate().then(success => {
        if (!success) {
          return;
        }
        let request = (this.form) ?  ApiService.patch('/form', this.model) :  ApiService.post('/form', this.model);
        request.then(response => {
            this.$emit("submitSuccess", response.data.obj);
            this.$nextTick(() => {
              this.$bvModal.hide("test-modal");
            });
          })
          .catch(error => {
            this.$_.each(error.response.data.fields, (item, key) => {
               this.$refs.formValidation.setErrors({
                [key]: item
              });
            });
          });
      });
    }
  }
};
</script>